module.exports = __webpack_public_path__ + "static/media/anonymous.31cb6acd.png";